export function Field({ label, name, value, onChange, placeholder, type = "text", required, textarea, testid }) {
  const cls =
    "w-full rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--surface-elevated))] px-4 py-3 text-sm text-[hsl(var(--foreground))] placeholder-[hsl(var(--muted-foreground))] outline-none transition-all focus:border-brand focus:ring-2 focus:ring-[hsl(var(--brand)/0.2)]";

  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-medium uppercase tracking-widest text-muted-foreground">
        {label}
      </span>
      {textarea ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          data-testid={testid}
          rows={5}
          className={`${cls} resize-none`}
        />
      ) : (
        <input
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          data-testid={testid}
          className={cls}
        />
      )}
    </label>
  );
}
